import * as React from 'react';
import { compose } from 'recompose';
import { createStyles, Dialog, Typography } from '@material-ui/core';
import { useModalTitle } from '../../hooks';
import { ActionIcon, withBaseProps } from '@topconagriculture/react-components';
import { ModalContent, ModalActions, ModalActionButton } from '../Modal';
const styles = (theme) => createStyles({
    modalWrapper: {
        overflowY: 'visible',
        borderRadius: 5,
    },
    scrollBodyWrapper: {
        display: 'grid',
    },
    closeIcon: {
        position: 'absolute',
        top: 10,
        right: 10,
        cursor: 'pointer',
    },
    modalMessage: {
        color: theme.color.font.dark,
        fontSize: theme.font.size.medium,
        lineHeight: theme.font.lineHeight.big,
    },
    label: {
        fontWeight: theme.font.weight.bold,
    },
    title: {
        paddingRight: 2 * theme.space.padding.large,
    },
});
const NavigationPromptModal = (props) => {
    const { open, classes, title, description, confirmBtnText, onCancel, onConfirm } = props;
    useModalTitle(title);
    return (React.createElement(Dialog, { open: open, classes: { paper: classes.modalWrapper, scrollBody: classes.scrollBodyWrapper } },
        React.createElement(ActionIcon, { className: classes.closeIcon, iconName: "close", onClick: onCancel, iconSize: 16 }),
        React.createElement(ModalContent, null,
            React.createElement(Typography, { variant: "caption", className: classes.modalMessage }, description)),
        React.createElement(ModalActions, { closeModal: onCancel },
            React.createElement(ModalActionButton, { action: onConfirm, btnLabel: confirmBtnText }))));
};
export default compose(withBaseProps({ styles }))(NavigationPromptModal);
//# sourceMappingURL=NavigationPromptModal.js.map